export { default as videoCallSchedulingModel } from './model'
